export const csvTableFormat = [
  {
    row: 'Nome',
    required: true,
    additional_information: 'Nome do serviço',
    values: '',
    format: 'Texto Livre',
  },

  {
    row: 'Tipo  Cobrança',
    required: true,
    additional_information:
      '1 = Unidade, 2 = Metro Quadrado, 3 = Metro Linear, 4 = Quilos (Unidade de cobrança)',
    values: '1, 2, 3 ou 4',
    format: 'Número',
  },
  {
    row: 'Tipo Atendimento',
    required: true,
    additional_information: '1 = Na Lavanderia, 2 = No Cliente',
    values: '1 ou 2',
    format: 'Número',
  },
  {
    row: 'Tempo Execução',
    required: true,
    additional_information: 'Não pode ser maior que 23:59.',
    values: 'HH:MM',
    format: 'Horas:minutos',
  },
  {
    row: 'Valor Base',
    required: false,
    additional_information:
      'Valor a ser cobrado pelo serviço, centavos separados por ponto!',
    values: 'Ex: 1.000,50 (Mil Reais e cinquenta centavos)',
    format: 'Número',
  },
  {
    row: 'Percentual Técnico',
    required: false,
    additional_information: 'Ignorado caso haja Valor Técnico!',
    values: 'Ex: 50,50 (Cinquenta inteiros e cinquenta centésimos por cento)',
    format: 'Número',
  },
  {
    row: 'Valor Técnico',
    required: false,
    additional_information: 'Ignorado caso haja Percentual Técnico!',
    values: 'Ex: 550,50 (Quinhetos reais e cinquenta centávos)',
    format: 'Número',
  },
  {
    row: 'Valor Editável',
    required: false,
    additional_information:
      'Valor editável na hora de cadastrar a OS. (Caso não fornecido não será editável)',
    values: '0 ou 1',
    format: 'Número',
  },
  {
    row: 'Ativo',
    required: false,
    additional_information:
      '0 = Inátivo, 1 = Ativo (Caso não fornecido será ativo)',
    values: '0 ou 1',
    format: 'Número',
  },
]
